// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`DailyCalorieGuidance when loading is false should render correctly and match snapshot 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="wrapper transparent borderRadius0"
        data-testid="section-wrapper"
        style="margin-top: 0px; margin-bottom: 0px;"
      >
        <div
          class="content"
        >
          <div
            class="wrapper brandYellow200 borderRadius16"
            data-testid="section-wrapper"
            style="margin-top: 0px; margin-bottom: 0px; padding: 32px 32px 40px 32px;"
          >
            <div
              class="header 
        startAlign"
            >
              <div
                class="title noMargin header"
              >
                <h2
                  class="hyphens textRegular16 nomargin brandBlue500 scale"
                >
                  edit_daily_amount.daily_calorie_guidance.option_selector.title
                </h2>
              </div>
            </div>
            <div
              class="content"
            >
              <div
                class="container"
              >
                <button
                  class="button buttonMultiLine"
                  type="button"
                >
                  <span
                    class="hyphens display28 nomargin brandBlue500 scale tight"
                  >
                    -
                  </span>
                </button>
                <div
                  class="selectedOption"
                >
                  <p
                    class="hyphens display28 nomargin brandBlue500 scale tight"
                  >
                    400g
                  </p>
                  <p
                    class="hyphens textRegular16 nomargin brandBlue400 scale tight"
                  >
                    1400 kcals
                  </p>
                </div>
                <button
                  class="button buttonMultiLine"
                  type="button"
                >
                  <span
                    class="hyphens display28 nomargin brandBlue500 scale tight"
                  >
                    +
                  </span>
                </button>
              </div>
              <div
                class="wrapper transparent borderRadius0"
                data-testid="section-wrapper"
                style="margin-top: 32px; margin-bottom: 0px;"
              >
                <div
                  class="content"
                >
                  <div
                    class="container "
                  >
                    <div
                      class="scale"
                    >
                      <p
                        class="hyphens textRegular16 nomargin brandYellow700 scale"
                      >
                        0 kcals
                      </p>
                      <p
                        class="hyphens textRegular16 nomargin brandYellow700 scale"
                      >
                        2000 kcals
                      </p>
                    </div>
                    <div
                      class="bar"
                    >
                      <div
                        class="fill"
                        style="width: -1%; left: 5.5%;"
                      />
                      <div
                        class="value "
                        style="left: 0%;"
                      >
                        <svg
                          height="12"
                          viewBox="0 0 18 12"
                          width="100%"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.33686 1.64689C8.13115 0.766138 9.51302 0.766138 10.3073 1.64689L14.2331 6L16.6325 8.66056C17.7928 9.94714 16.8798 12 15.1473 12H2.49687C0.764366 12 -0.148651 9.94714 1.01164 8.66056L7.33686 1.64689Z"
                            fill="#174f78"
                          />
                        </svg>
                        <p
                          class="hyphens textRegular16 nomargin bold brandBlue500 scale"
                        >
                          ~400 kcal
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="calorieRangeNote"
                    data-testid="daily-calorie-guidance-bar-key"
                  >
                    <div
                      class="calorieRangeKey"
                    />
                    <span
                      class="hyphens textRegular16 brandBlue500 scale"
                    >
                      =
                    </span>
                    <p
                      class="hyphens textRegular16 nomargin brandBlue500"
                    >
                      edit_daily_amount.daily_calorie_guidance.bar_key
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="wrapper transparent borderRadius0"
            data-testid="section-wrapper"
            style="margin-top: 4px; margin-bottom: 0px;"
          >
            <div
              class="content"
            />
          </div>
        </div>
      </div>
      <div
        class="wrapper transparent borderRadius0"
        data-testid="section-wrapper"
        style="margin-top: 0px; margin-bottom: 0px;"
      >
        <div
          class="content"
        />
      </div>
      <div
        class="Toastify"
      />
    </div>
  </body>,
  "container": <div>
    <div
      class="wrapper transparent borderRadius0"
      data-testid="section-wrapper"
      style="margin-top: 0px; margin-bottom: 0px;"
    >
      <div
        class="content"
      >
        <div
          class="wrapper brandYellow200 borderRadius16"
          data-testid="section-wrapper"
          style="margin-top: 0px; margin-bottom: 0px; padding: 32px 32px 40px 32px;"
        >
          <div
            class="header 
        startAlign"
          >
            <div
              class="title noMargin header"
            >
              <h2
                class="hyphens textRegular16 nomargin brandBlue500 scale"
              >
                edit_daily_amount.daily_calorie_guidance.option_selector.title
              </h2>
            </div>
          </div>
          <div
            class="content"
          >
            <div
              class="container"
            >
              <button
                class="button buttonMultiLine"
                type="button"
              >
                <span
                  class="hyphens display28 nomargin brandBlue500 scale tight"
                >
                  -
                </span>
              </button>
              <div
                class="selectedOption"
              >
                <p
                  class="hyphens display28 nomargin brandBlue500 scale tight"
                >
                  400g
                </p>
                <p
                  class="hyphens textRegular16 nomargin brandBlue400 scale tight"
                >
                  1400 kcals
                </p>
              </div>
              <button
                class="button buttonMultiLine"
                type="button"
              >
                <span
                  class="hyphens display28 nomargin brandBlue500 scale tight"
                >
                  +
                </span>
              </button>
            </div>
            <div
              class="wrapper transparent borderRadius0"
              data-testid="section-wrapper"
              style="margin-top: 32px; margin-bottom: 0px;"
            >
              <div
                class="content"
              >
                <div
                  class="container "
                >
                  <div
                    class="scale"
                  >
                    <p
                      class="hyphens textRegular16 nomargin brandYellow700 scale"
                    >
                      0 kcals
                    </p>
                    <p
                      class="hyphens textRegular16 nomargin brandYellow700 scale"
                    >
                      2000 kcals
                    </p>
                  </div>
                  <div
                    class="bar"
                  >
                    <div
                      class="fill"
                      style="width: -1%; left: 5.5%;"
                    />
                    <div
                      class="value "
                      style="left: 0%;"
                    >
                      <svg
                        height="12"
                        viewBox="0 0 18 12"
                        width="100%"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.33686 1.64689C8.13115 0.766138 9.51302 0.766138 10.3073 1.64689L14.2331 6L16.6325 8.66056C17.7928 9.94714 16.8798 12 15.1473 12H2.49687C0.764366 12 -0.148651 9.94714 1.01164 8.66056L7.33686 1.64689Z"
                          fill="#174f78"
                        />
                      </svg>
                      <p
                        class="hyphens textRegular16 nomargin bold brandBlue500 scale"
                      >
                        ~400 kcal
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="calorieRangeNote"
                  data-testid="daily-calorie-guidance-bar-key"
                >
                  <div
                    class="calorieRangeKey"
                  />
                  <span
                    class="hyphens textRegular16 brandBlue500 scale"
                  >
                    =
                  </span>
                  <p
                    class="hyphens textRegular16 nomargin brandBlue500"
                  >
                    edit_daily_amount.daily_calorie_guidance.bar_key
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="wrapper transparent borderRadius0"
          data-testid="section-wrapper"
          style="margin-top: 4px; margin-bottom: 0px;"
        >
          <div
            class="content"
          />
        </div>
      </div>
    </div>
    <div
      class="wrapper transparent borderRadius0"
      data-testid="section-wrapper"
      style="margin-top: 0px; margin-bottom: 0px;"
    >
      <div
        class="content"
      />
    </div>
    <div
      class="Toastify"
    />
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
